import { observer } from "mobx-react";
import { Button } from "primereact/button";
import { Sidebar } from "primereact/sidebar";
import React, { useState } from "react";
import styled from "styled-components";
import { withWSErrorContainer } from "../../../error/withWSErrorContainer";
import { MobileNav } from "./MobileNav";

const MOBILE_NAV_ID = "cvp-mobile-nav-sidebar";

export const MobileMenu = withWSErrorContainer(
  observer(() => {
    const [open, setOpen] = useState(false);

    return (
      <>
        <StyledMenuBtn
          className="cvp-menu-btn"
          icon="pi pi-bars"
          onClick={() => setOpen(true)}
          aria-label="Åpne navigasjonsmeny"
          aria-controls={MOBILE_NAV_ID}
          aria-expanded={open}
          aria-haspopup
        />

        <StyledSidebar
          id={MOBILE_NAV_ID}
          className="cvp-side-bar"
          visible={open}
          onHide={() => setOpen(false)}
        >
          <MobileNav />
        </StyledSidebar>
      </>
    );
  })
);

const StyledSidebar = styled(Sidebar)`
  &.cvp-side-bar {
    width: 255px;
    .p-sidebar-content {
      padding: 0;
    }
  }
`;

export const StyledMenuBtn = styled(Button)`
  &.cvp-menu-btn {
    background-color: transparent;
    border: none;
    color: var(--primary-500);

    &:hover:not(:disabled) {
      background-color: transparent;
      color: var(--primary-300-relative);
    }
    &:active:not(:disabled) {
      border: none;
    }
    &:focus:not(:disabled) {
      box-shadow: none;
    }
  }
`;
